// extracted by mini-css-extract-plugin
export default {"backtolive":"BackToLive_backtolive__rcGtU"};